var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrationArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 508,
    height: 346,
    viewBox: "0 0 508 346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1.381,
    y1: 0.1,
    x2: -1.008,
    y2: 1.142,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.504,
    y1: -0.004,
    x2: 0.489,
    y2: 1.888,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -19.175,
    y1: 68.422,
    x2: -20.694,
    y2: 69.76,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -11.202,
    y1: 43.737,
    x2: -10.18,
    y2: 43.737,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -56.531,
    y1: 195.826,
    x2: -53.24,
    y2: 193.47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1.114,
    y1: -1.222,
    x2: -0.579,
    y2: 3.818,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 14.935,
    y1: 0.23,
    x2: -65.87,
    y2: 1.744,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 20.836,
    y1: 0.119,
    x2: -59.969,
    y2: 1.633,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1259.239,
    y1: -141.851,
    x2: -1253.575,
    y2: -142.682,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23372",
    "data-name": "Group 23372",
    transform: "translate(-1074 -891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12494",
    "data-name": "Rectangle 12494",
    width: 508,
    height: 346,
    transform: "translate(1074 891)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23371",
    "data-name": "Group 23371",
    transform: "translate(6615.279 19690.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M1004.3,423.394a24.56,24.56,0,1,0-48.962-3.938v0a26.3,26.3,0,0,1-10.44,18.934,31.247,31.247,0,0,0-12.439,22.555v0a29.369,29.369,0,0,1-13.316,22.293,35.57,35.57,0,1,0,54.772,32.719q.126-1.57.116-3.118a36.692,36.692,0,0,1,11.333-26.755,31.373,31.373,0,0,0,8.731-30.258,20.563,20.563,0,0,1,4.361-18.409A24.44,24.44,0,0,0,1004.3,423.394Z",
    transform: "translate(-6040.902 -19028.885)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M947.439,559.845a.5.5,0,0,1-.407-.779c40.032-57.829,55.577-111.415,55.729-111.95a.5.5,0,0,1,.954.272c-.153.536-15.744,54.28-55.868,112.243A.5.5,0,0,1,947.439,559.845Z",
    transform: "translate(-6063.106 -19054.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M1035.527,469.845a.494.494,0,0,1-.326-.122c-5.624-4.894-8.574-20.284-8.7-20.937a.5.5,0,1,1,.974-.183c.03.156,3.009,15.7,8.373,20.372a.5.5,0,0,1-.325.87Z",
    transform: "translate(-6103.203 -19054.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M1045.17,482.145a.5.5,0,0,1-.131-.974c.1-.029,10.332-2.887,16.675-8.52a.5.5,0,0,1,.659.742c-6.518,5.789-16.643,8.617-17.071,8.734A.509.509,0,0,1,1045.17,482.145Z",
    transform: "translate(-6112.365 -19067.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M1005.22,534.3a.493.493,0,0,1-.383-.181c-7.624-9.266-8.753-24.614-8.763-24.768a.5.5,0,1,1,.989-.068c.011.151,1.12,15.188,8.54,24.206a.5.5,0,0,1-.382.811Z",
    transform: "translate(-6087.868 -19085.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M1014.928,550.442c-.308,0-.495-.009-.547-.013a.5.5,0,0,1,.057-.99c.109,0,11.095.507,22.758-9.025a.5.5,0,1,1,.628.768C1027.2,549.868,1017.342,550.442,1014.928,550.442Z",
    transform: "translate(-6096.861 -19101.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M972.283,633.365c-.953,0-1.5-.04-1.528-.042a.5.5,0,0,1,.079-.989c.13.009,13.022.939,24.017-6.734a.5.5,0,1,1,.567.813C986.38,632.721,976.1,633.365,972.283,633.365Z",
    transform: "translate(-6074.877 -19144.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M961.57,616.06a.5.5,0,0,1-.356-.151c-.324-.334-7.942-8.354-8.4-23.795a.5.5,0,1,1,.991-.029c.447,15.033,8.046,23.055,8.123,23.134a.5.5,0,0,1-.357.841Z",
    transform: "translate(-6066.064 -19127.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M857.927,310.025a31.469,31.469,0,1,1,45.065,43.937l0,0A33.7,33.7,0,0,0,893.514,380a40.037,40.037,0,0,1-11.285,31.014l0,0a37.629,37.629,0,0,0-10.294,31.64,45.576,45.576,0,1,1-77.74-25.288q1.41-1.446,2.912-2.74a47.013,47.013,0,0,0,16.271-33.487,40.2,40.2,0,0,1,21.846-33.927,26.346,26.346,0,0,0,14.092-19.723A31.324,31.324,0,0,1,857.927,310.025Z",
    transform: "translate(-5979.592 -18980.328)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M854.072,511.087a.52.52,0,0,1-.122-.015.5.5,0,0,1-.36-.6C875.713,422.916,914.431,362.595,914.82,362a.5.5,0,1,1,.832.54c-.387.6-39.02,60.792-61.1,148.178A.5.5,0,0,1,854.072,511.087Z",
    transform: "translate(-6016.046 -19011.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M950.8,405.061a13.129,13.129,0,0,1-1.793-.116.5.5,0,1,1,.135-.983c9.076,1.245,26.632-9,26.809-9.105a.5.5,0,0,1,.5.855,107.036,107.036,0,0,1-10.11,5.095C959.876,403.634,954.661,405.061,950.8,405.061Z",
    transform: "translate(-6063.931 -19027.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M942.193,389.459a.5.5,0,0,1-.447-.28c-.061-.125-6.037-12.638-5.943-23.775a.5.5,0,0,1,.5-.492h0a.5.5,0,0,1,.492.5c-.091,10.908,5.785,23.213,5.844,23.336a.5.5,0,0,1-.446.711Z",
    transform: "translate(-6057.49 -19012.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M908.554,488.519a.5.5,0,0,1-.014-.992c15-.44,30.485-12.069,30.639-12.186a.5.5,0,1,1,.6.789c-.157.12-15.886,11.938-31.21,12.389Z",
    transform: "translate(-6043.507 -19068.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M896.88,470.589a.492.492,0,0,1-.354-.149c-.1-.1-10.148-10.564-10.793-30.326a.5.5,0,0,1,.48-.511h.016a.5.5,0,0,1,.5.48,52.32,52.32,0,0,0,5.493,22.17,33.475,33.475,0,0,0,5.017,7.494.5.5,0,0,1-.355.843Z",
    transform: "translate(-6032.254 -19050.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M852.572,581.329a.5.5,0,0,1-.346-.141c-.121-.118-12.17-12.047-14.075-29.543a.5.5,0,0,1,.987-.108c1.866,17.146,13.663,28.824,13.781,28.94a.5.5,0,0,1-.347.851Z",
    transform: "translate(-6008.27 -19106.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M868.15,599.561c-.258,0-.4-.006-.412-.007a.5.5,0,0,1,.052-.991c.141.009,14.336.588,29.269-11.689a.5.5,0,0,1,.63.766C883.876,599,870.628,599.561,868.15,599.561Z",
    transform: "translate(-6022.948 -19124.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M800.178,696.017H942.215V667.589H800.178C803.218,667.589,803.218,696.017,800.178,696.017Z",
    transform: "translate(-5989.134 -19165.342)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M937.813,682.371V669.36c0-4.586-2.807-8.3-6.269-8.3H796.376a4.931,4.931,0,0,1-4.93-4.93h0a1.5,1.5,0,0,1,1.5-1.5H940.672c3.388,0,8.767,5.327,8.767,11.9V684.7c0,6.2-5.222,11.217-8.416,11.217H793.72a2.275,2.275,0,0,1-2.275-2.275h0a4.153,4.153,0,0,1,4.153-4.153H932.443C935.409,689.485,937.813,686.3,937.813,682.371Z",
    transform: "translate(-5984.732 -19158.809)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M942.77,679.342H809.591a.5.5,0,0,1,0-.992H942.77a.5.5,0,0,1,0,.992Z",
    transform: "translate(-5993.628 -19170.766)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M942.77,687.849H809.591a.5.5,0,0,1,0-.992H942.77a.5.5,0,0,1,0,.992Z",
    transform: "translate(-5993.628 -19175.051)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M942.77,696.357H809.591a.5.5,0,0,1,0-.992H942.77a.5.5,0,0,1,0,.992Z",
    transform: "translate(-5993.628 -19179.34)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M942.77,704.865H809.591a.5.5,0,0,1,0-.992H942.77a.5.5,0,0,1,0,.992Z",
    transform: "translate(-5993.628 -19183.629)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M942.77,713.373H809.591a.5.5,0,0,1,0-.992H942.77a.5.5,0,0,1,0,.992Z",
    transform: "translate(-5993.628 -19187.918)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11877",
    "data-name": "Group 11877",
    transform: "translate(-5174.926 -18535.158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7986",
    "data-name": "Rectangle 7986",
    width: 127.806,
    height: 30.85,
    rx: 15.425,
    transform: "translate(127.806 30.85) rotate(180)",
    fill: "#afd75f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 15.014,
    height: 23.759,
    rx: 7.242,
    transform: "translate(113.362 27.305) rotate(180)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7988",
    "data-name": "Rectangle 7988",
    width: 5.634,
    height: 23.759,
    rx: 2.817,
    transform: "translate(96.139 27.305) rotate(180)",
    fill: "#fff",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(-5167.127 -18742.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M976.629,304.286a.5.5,0,0,1-.191-.954c.6-.249,1.2-.516,1.8-.792a.5.5,0,1,1,.419.9c-.6.282-1.22.554-1.834.809A.493.493,0,0,1,976.629,304.286Z",
    transform: "translate(-910.692 -238.84)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M891.9,251.345c-.832,0-1.674-.022-2.5-.065a.5.5,0,0,1-.47-.521.5.5,0,0,1,.521-.47c1.321.069,2.656.082,3.99.04h.016a.5.5,0,0,1,.016.991Q892.685,251.346,891.9,251.345Zm8.072-.685a.5.5,0,0,1-.083-.984c1.311-.225,2.623-.506,3.9-.839a.5.5,0,1,1,.25.96c-1.305.34-2.646.628-3.984.857A.493.493,0,0,1,899.974,250.659Zm-17.048-.175a.475.475,0,0,1-.095-.009c-1.326-.257-2.659-.576-3.963-.947a.5.5,0,1,1,.272-.954c1.276.364,2.582.676,3.88.927a.5.5,0,0,1-.094.983Zm-10.083-3.168a.491.491,0,0,1-.2-.043c-1.238-.549-2.467-1.157-3.652-1.808a.5.5,0,1,1,.478-.869c1.16.637,2.363,1.233,3.576,1.771a.5.5,0,0,1-.2.949Zm-9.124-5.332a.494.494,0,0,1-.3-.1c-1.085-.809-2.149-1.674-3.161-2.572a.5.5,0,0,1,.658-.742c.991.879,2.033,1.726,3.1,2.518a.5.5,0,0,1-.3.894ZM856,234.768a.5.5,0,0,1-.377-.173c-.881-1.03-1.727-2.108-2.514-3.206a.5.5,0,1,1,.806-.578c.771,1.075,1.6,2.132,2.461,3.14a.5.5,0,0,1-.376.818Zm-5.924-8.743a.5.5,0,0,1-.44-.265c-.628-1.2-1.212-2.437-1.735-3.685a.5.5,0,1,1,.914-.384c.513,1.222,1.085,2.435,1.7,3.608a.5.5,0,0,1-.439.726Zm-3.825-9.846a.5.5,0,0,1-.479-.369c-.345-1.307-.637-2.646-.87-3.98a.5.5,0,0,1,.978-.17c.227,1.306.514,2.617.851,3.9a.5.5,0,0,1-.353.606A.51.51,0,0,1,846.255,216.179Zm-1.539-10.453a.5.5,0,0,1-.5-.478q-.031-.864-.031-1.721c0-.784.019-1.576.057-2.354a.489.489,0,0,1,.52-.471.5.5,0,0,1,.471.52c-.037.763-.056,1.538-.056,2.306q0,.84.031,1.685a.5.5,0,0,1-.478.513Zm.8-10.538a.494.494,0,0,1-.488-.589c.253-1.329.568-2.663.935-3.967a.5.5,0,1,1,.955.269c-.359,1.276-.667,2.583-.915,3.883A.5.5,0,0,1,845.519,195.189Z",
    transform: "translate(-844.189 -182.276)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M852.717,176.94a.5.5,0,0,1-.454-.7c.265-.6.55-1.215.846-1.817a.5.5,0,0,1,.89.438c-.29.589-.568,1.187-.828,1.778A.5.5,0,0,1,852.717,176.94Z",
    transform: "translate(-848.238 -174.151)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11880",
    "data-name": "Group 11880",
    transform: "translate(-5136.15 -18768.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M907.141,126.954a.5.5,0,0,1-.171-.962c.628-.23,1.266-.448,1.9-.65a.5.5,0,0,1,.3.945c-.617.2-1.241.411-1.857.636A.5.5,0,0,1,907.141,126.954Z",
    transform: "translate(-906.645 -123.124)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M976.536,184.116a.5.5,0,0,1-.471-.654c.415-1.234.781-2.5,1.09-3.772a.5.5,0,0,1,.964.235c-.316,1.3-.691,2.592-1.113,3.853A.5.5,0,0,1,976.536,184.116Zm2.194-10.164-.051,0a.5.5,0,0,1-.443-.544c.133-1.3.211-2.617.234-3.92a.489.489,0,0,1,.5-.487.5.5,0,0,1,.487.5c-.023,1.331-.1,2.678-.239,4A.5.5,0,0,1,978.729,173.952Zm-.088-10.4a.5.5,0,0,1-.492-.438c-.153-1.3-.361-2.6-.62-3.876a.5.5,0,1,1,.971-.2c.265,1.3.478,2.632.634,3.957a.5.5,0,0,1-.435.551ZM976.3,153.424a.5.5,0,0,1-.468-.331c-.432-1.23-.921-2.457-1.455-3.646a.5.5,0,0,1,.905-.406c.545,1.214,1.045,2.466,1.486,3.723a.5.5,0,0,1-.3.632A.487.487,0,0,1,976.3,153.424Zm-4.5-9.363a.5.5,0,0,1-.421-.233c-.691-1.105-1.438-2.194-2.22-3.237a.5.5,0,0,1,.794-.595c.8,1.065,1.561,2.177,2.267,3.305a.5.5,0,0,1-.157.683A.488.488,0,0,1,971.8,144.061Zm-6.449-8.151a.5.5,0,0,1-.353-.147c-.917-.928-1.883-1.829-2.873-2.676a.5.5,0,1,1,.645-.754c1.01.865,2,1.785,2.933,2.732a.5.5,0,0,1-.353.845Zm-8.071-6.554a.5.5,0,0,1-.268-.079c-1.1-.708-2.238-1.377-3.386-1.987a.5.5,0,1,1,.465-.876c1.173.623,2.337,1.306,3.459,2.029a.5.5,0,0,1-.269.913Zm-9.306-4.639a.492.492,0,0,1-.171-.03c-1.224-.449-2.482-.853-3.74-1.2a.5.5,0,0,1,.262-.957c1.285.353,2.57.764,3.82,1.223a.5.5,0,0,1-.171.961Zm-24.43-2.171a.5.5,0,0,1-.085-.985c1.308-.228,2.645-.4,3.976-.522a.5.5,0,0,1,.088.988c-1.3.116-2.613.288-3.893.511A.512.512,0,0,1,923.545,122.546Zm14.33-.311a.476.476,0,0,1-.065,0c-1.293-.169-2.608-.284-3.91-.344a.5.5,0,0,1,.046-.991c1.33.062,2.673.18,3.993.352a.5.5,0,0,1-.064.988Z",
    transform: "translate(-914.913 -120.894)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M1023.539,261.179a.5.5,0,0,1-.434-.735c.316-.575.622-1.16.91-1.739a.5.5,0,0,1,.888.442c-.293.591-.606,1.188-.928,1.775A.5.5,0,0,1,1023.539,261.179Z",
    transform: "translate(-965.313 -190.216)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881",
    transform: "translate(-5156.261 -18757.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M932.369,201.356a.569.569,0,0,0,.076-.655l-3.331-6.048a30.078,30.078,0,0,0,3.277-9.177l6.4-2.573a.567.567,0,0,0,.355-.555l-.414-8.272a.568.568,0,0,0-.409-.516l-6.628-1.92a30.085,30.085,0,0,0-4.178-8.8l2.71-6.351a.567.567,0,0,0-.141-.643l-6.142-5.556a.569.569,0,0,0-.655-.076l-6.048,3.331a30.077,30.077,0,0,0-9.177-3.277l-2.573-6.4a.567.567,0,0,0-.555-.355l-8.272.415a.566.566,0,0,0-.516.409l-1.92,6.628a30.073,30.073,0,0,0-8.8,4.178l-6.351-2.709a.568.568,0,0,0-.643.141l-5.556,6.142a.568.568,0,0,0-.076.654l3.331,6.048a30.061,30.061,0,0,0-3.277,9.178l-6.4,2.573a.568.568,0,0,0-.355.555l.414,8.272a.567.567,0,0,0,.409.516l6.628,1.92a30.048,30.048,0,0,0,4.178,8.8l-2.71,6.351a.567.567,0,0,0,.141.643l6.142,5.556a.568.568,0,0,0,.654.076L888,206.524a30.074,30.074,0,0,0,9.177,3.277l2.573,6.4a.566.566,0,0,0,.554.355l8.272-.414a.568.568,0,0,0,.516-.409l1.92-6.628a30.076,30.076,0,0,0,8.8-4.178l6.351,2.709a.567.567,0,0,0,.643-.141Z",
    transform: "translate(-866.096 -143.506)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M931.514,217.017a8.1,8.1,0,1,1,2.368-.356A8.112,8.112,0,0,1,931.514,217.017Zm0-14.712a6.646,6.646,0,0,0-1.945.294,6.61,6.61,0,1,0,8.257,4.383h0a6.621,6.621,0,0,0-6.312-4.677Z",
    transform: "translate(-894.983 -172.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M918.383,216.6a20.753,20.753,0,0,1-20.691-19.691q-.027-.527-.027-1.049a20.729,20.729,0,0,1,41.432-1.026q.026.524.026,1.048a20.861,20.861,0,0,1-.271,3.359L937.384,199a19.344,19.344,0,0,0,.252-3.118q0-.487-.024-.973h0a19.241,19.241,0,0,0-38.458.944q0,.49.025.982a19.245,19.245,0,0,0,29.91,15.036l.828,1.236a20.7,20.7,0,0,1-10.484,3.468Q918.906,216.6,918.383,216.6Z",
    transform: "translate(-882.008 -159.452)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M846.483,118.8l-2.129-3.23a16.853,16.853,0,0,0,1.423-5.271l3.462-1.722a.317.317,0,0,0,.174-.325l-.6-4.6a.319.319,0,0,0-.251-.27l-3.787-.778a16.843,16.843,0,0,0-2.725-4.732l1.232-3.667a.318.318,0,0,0-.107-.353L839.5,91.017a.317.317,0,0,0-.368-.013l-3.23,2.129a16.839,16.839,0,0,0-5.271-1.422l-1.722-3.462a.317.317,0,0,0-.325-.174l-4.6.6a.318.318,0,0,0-.27.251l-.778,3.787a16.85,16.85,0,0,0-4.731,2.724L814.531,94.2a.318.318,0,0,0-.353.108l-2.83,3.677a.317.317,0,0,0-.013.369l2.129,3.23a16.85,16.85,0,0,0-1.423,5.271l-3.461,1.721a.319.319,0,0,0-.174.326l.6,4.6a.317.317,0,0,0,.251.27l3.787.778a16.853,16.853,0,0,0,2.724,4.732l-1.231,3.667a.318.318,0,0,0,.108.353l3.677,2.831a.319.319,0,0,0,.369.013l3.23-2.129a16.86,16.86,0,0,0,5.271,1.422l1.722,3.462a.318.318,0,0,0,.326.174l4.6-.6a.318.318,0,0,0,.27-.251l.778-3.787a16.86,16.86,0,0,0,4.732-2.725l3.667,1.231a.318.318,0,0,0,.353-.107l2.831-3.678A.318.318,0,0,0,846.483,118.8Z",
    transform: "translate(-5993.278 -18873.244)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M844.8,129.341a4.866,4.866,0,1,1,4.524-6.656h0a4.871,4.871,0,0,1-4.524,6.656Zm0-8.244a3.377,3.377,0,1,0,3.144,2.135A3.367,3.367,0,0,0,844.8,121.1Z",
    transform: "translate(-6009.171 -18889.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883",
    transform: "translate(-5189.67 -18769.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M879.653,168.017a.5.5,0,0,1-.3-.891c.514-.392,1.018-.808,1.5-1.238a.5.5,0,0,1,.663.738c-.5.447-1.023.881-1.559,1.29A.494.494,0,0,1,879.653,168.017Z",
    transform: "translate(-839.27 -143.248)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M824.026,158.648h-.006a25.277,25.277,0,0,1-3.941-.36.5.5,0,1,1,.167-.977,24.372,24.372,0,0,0,3.787.345.5.5,0,0,1-.006.992Zm6.253-.724a.5.5,0,0,1-.119-.978,24.686,24.686,0,0,0,3.136-1c.159-.063.318-.127.475-.193a.5.5,0,0,1,.385.915c-.164.069-.328.135-.494.2a25.773,25.773,0,0,1-3.263,1.046A.515.515,0,0,1,830.279,157.924Zm-16.138-1.462a.49.49,0,0,1-.2-.044,25.477,25.477,0,0,1-3.473-1.9.5.5,0,1,1,.542-.831,24.5,24.5,0,0,0,3.337,1.822.5.5,0,0,1-.2.948Zm-8.2-5.931a.5.5,0,0,1-.367-.162,25.207,25.207,0,0,1-2.429-3.124.5.5,0,0,1,.829-.546,24.3,24.3,0,0,0,2.333,3,.5.5,0,0,1-.366.83Zm-5.15-8.715a.5.5,0,0,1-.469-.335,25.508,25.508,0,0,1-.989-3.832.5.5,0,0,1,.977-.172,24.572,24.572,0,0,0,.95,3.682.5.5,0,0,1-.308.63A.5.5,0,0,1,800.79,141.816Z",
    transform: "translate(-799.033 -128.786)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M799.233,123.331h-.041a.5.5,0,0,1-.453-.535c.055-.667.138-1.342.246-2.007a.5.5,0,0,1,.979.16c-.1.639-.184,1.288-.237,1.929A.5.5,0,0,1,799.233,123.331Z",
    transform: "translate(-798.737 -120.371)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884",
    transform: "translate(-5179.861 -18789.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M819.011,88.215a.5.5,0,0,1-.3-.892c.536-.4,1.1-.792,1.663-1.152a.5.5,0,1,1,.531.838c-.545.346-1.083.718-1.6,1.107A.493.493,0,0,1,819.011,88.215Z",
    transform: "translate(-818.514 -82.292)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M866.042,101.167a.5.5,0,0,1-.491-.435,24.31,24.31,0,0,0-.745-3.665.5.5,0,0,1,.954-.272,25.349,25.349,0,0,1,.775,3.815.5.5,0,0,1-.431.554A.438.438,0,0,1,866.042,101.167Zm-3.174-9.441a.5.5,0,0,1-.43-.247,24.443,24.443,0,0,0-2.116-3.082.5.5,0,0,1,.772-.622,25.331,25.331,0,0,1,2.2,3.207.5.5,0,0,1-.429.744ZM856.25,84.29a.49.49,0,0,1-.3-.1,24.546,24.546,0,0,0-3.159-2,.5.5,0,1,1,.465-.876,25.582,25.582,0,0,1,3.287,2.082.5.5,0,0,1-.3.894Zm-22.662-3.713a.5.5,0,0,1-.155-.967,25.391,25.391,0,0,1,3.779-.931.5.5,0,1,1,.163.978,24.478,24.478,0,0,0-3.632.9A.5.5,0,0,1,833.588,80.577Zm13.657-.534a.486.486,0,0,1-.119-.014,24.454,24.454,0,0,0-3.69-.608.5.5,0,0,1,.086-.988,25.426,25.426,0,0,1,3.84.632.5.5,0,0,1-.117.978Z",
    transform: "translate(-825.862 -78.429)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M898.322,137.748a.524.524,0,0,1-.1-.01.5.5,0,0,1-.383-.588c.134-.635.243-1.28.325-1.916a.5.5,0,1,1,.984.127c-.085.663-.2,1.333-.339,1.993A.5.5,0,0,1,898.322,137.748Z",
    transform: "translate(-858.489 -106.842)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M837.436,129.114a11.931,11.931,0,1,1,11.917-11.046c0,.034,0,.069-.008.1l-1.483-.123q.036-.428.036-.859a10.531,10.531,0,0,0-.089-1.367,10.454,10.454,0,0,0-20.82,1.328,10.457,10.457,0,0,0,16.935,8.226l.924,1.166a11.969,11.969,0,0,1-7.411,2.571Z",
    transform: "translate(-6001.896 -18881.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11886",
    "data-name": "Group 11886",
    transform: "translate(-5280.043 -18727.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M846.761,231.631l9.357.586a8.688,8.688,0,0,1,8.144,8.8L861,463.137a9.117,9.117,0,0,1-9.311,8.981l-64.272-1.373Z",
    transform: "translate(-702.655 -218.011)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M680.742,226.17,799.4,220.434a4.208,4.208,0,0,1,4.41,4.338l-7.32,228.885a8.8,8.8,0,0,1-9.147,8.51l-83.4-3.353Z",
    transform: "translate(-648.89 -212.365)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M693.513,228.139l104.361-13.316a4.424,4.424,0,0,1,4.983,4.485l-5.076,230.853a6.115,6.115,0,0,1-5.935,5.979l-76.778,2.245Z",
    transform: "translate(-655.327 -209.521)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M627.278,211.312l114.417-7.123a9.907,9.907,0,0,1,10.522,9.888v235.74a8.656,8.656,0,0,1-8.656,8.656H638.071a9.367,9.367,0,0,1-9.353-8.863l-12.18-226.234A11.469,11.469,0,0,1,627.278,211.312Z",
    transform: "translate(-616.521 -204.17)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7989",
    "data-name": "Rectangle 7989",
    width: 17.786,
    height: 70.348,
    rx: 8.893,
    transform: "translate(126.803 22.511)",
    fill: "#66f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    "data-name": "Group 11887",
    transform: "translate(-5452.923 -18798.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M338.788,142.042s-38.16,19.641-55.991-1.395c-14.33-16.906,10.425-4.609,34.055-1.2a1.468,1.468,0,0,0,.541-2.884c-17.936-4.142-44.7-12.068-45.89-22.675-1.793-16.014,3.2-9.166,23.279.58s26.013,6.111,13.632-2.182-36.64-9.317-39.205-17.785-.417-22.564-.316-28.934,31.167-4.336,35.946,5.868,4.732,28.964,12.558,35.327,3.656-11.811.537-21.554-3.379-16.211,7.813-9.97,12.032,23.071,9.23,34.348-.891,18.888.925,13.47,6.025-22.542,4.081-28.894S362.849,103.98,338.788,142.042Z",
    transform: "translate(-267.954 -61.937)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11888",
    "data-name": "Group 11888",
    transform: "translate(-5472.788 -18740.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M311.448,212.425s-12.892,32.2-34.919,28.809c-17.7-2.729,3.922-8.336,20.155-18.771a1.187,1.187,0,0,0-1.2-2.047c-13.144,6.973-33.682,16.314-40.026,10.467-9.577-8.826-2.9-7.291,14.518-11.978s19.117-10.049,7.166-8.553-27.3,13.722-33.355,9.911-12.207-13.553-15.52-17.5S245,183.61,253.321,187.309s18.231,15.175,26.379,14.914-4.024-9.147-11.09-13.442-10.65-8.107-.512-10.225,19.567,7.71,23.83,16.078,9.462,12,7.7,7.733-8.264-16.952-12.815-19.8S305.973,176.444,311.448,212.425Z",
    transform: "translate(-227.903 -178.264)",
    fill: "#9c3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M394.991,144.5H576.142a18.767,18.767,0,0,1,18.743,17.813l13.371,262.636a13.84,13.84,0,0,1-13.57,14.541l-207.623,3.773a13.136,13.136,0,0,1-13.375-13.134V165.8A21.3,21.3,0,0,1,394.991,144.5Z",
    transform: "translate(-5774.171 -18901.686)",
    fill: "#0c1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M423.906,686.916H423.9l-23.232-.3a14.328,14.328,0,0,1-14.088-14.272V637.269a.5.5,0,1,1,.992,0v35.076a13.332,13.332,0,0,0,13.109,13.28l23.231.3a.5.5,0,0,1-.006.992Z",
    transform: "translate(-5780.668 -19149.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M387.076,610.086a.5.5,0,0,1-.5-.5V603.91a.5.5,0,0,1,.992,0v5.681A.5.5,0,0,1,387.076,610.086Z",
    transform: "translate(-5780.668 -19132.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M423.063,166.538c23.807,3.228,100.443,6.981,168.126,1.785a5.507,5.507,0,0,1,5.93,5.193l13.493,253.873a6.337,6.337,0,0,1-5.953,6.664c-28.467,1.684-145.7,8.2-187.517,3.817a5.02,5.02,0,0,1-4.492-4.968l.276-257.719C412.9,171.561,419.474,166.051,423.063,166.538Z",
    transform: "translate(-5793.808 -18914.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11931",
    "data-name": "Group 11931",
    transform: "translate(-5347.197 -18719.207)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1502",
    "data-name": "Ellipse 1502",
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    transform: "translate(9.092 0)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M484.143,297.308h37.276a2.886,2.886,0,0,0,2.424-4.449c-3.166-4.954-9.791-12.233-21.263-11.9a25.987,25.987,0,0,0-20.906,11.606A3.016,3.016,0,0,0,484.143,297.308Z",
    transform: "translate(-481.123 -251.256)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11889",
    "data-name": "Group 11889",
    transform: "translate(-5278.638 -18727.084)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M686.5,210.059a1.849,1.849,0,0,0,1.93-1.826,2.027,2.027,0,0,0-2.036-1.861L620.786,205.2a1.289,1.289,0,0,0-1.325,1.836l.4,1.149a3.009,3.009,0,0,0,2.643,1.871Z",
    transform: "translate(-619.355 -205.202)",
    fill: "#e3e3eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11890",
    "data-name": "Group 11890",
    transform: "translate(-5278.638 -18716.938)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M620.786,225.661a1.289,1.289,0,0,0-1.325,1.836l.4,1.149a3.009,3.009,0,0,0,2.643,1.871H686.5a1.849,1.849,0,0,0,1.93-1.826,2.027,2.027,0,0,0-2.036-1.861Z",
    transform: "translate(-619.355 -225.66)",
    fill: "#e3e3eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11891",
    "data-name": "Group 11891",
    transform: "translate(-5278.638 -18706.641)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M620.786,246.417a1.289,1.289,0,0,0-1.325,1.836l.4,1.149a3.009,3.009,0,0,0,2.643,1.871H686.5a1.849,1.849,0,0,0,1.93-1.826,2.027,2.027,0,0,0-2.036-1.861Z",
    transform: "translate(-619.355 -246.416)",
    fill: "#e3e3eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M652.283,278.176a1.883,1.883,0,0,0,1.958-1.826,2.036,2.036,0,0,0-2.009-1.9l-30.425-1.1a1.546,1.546,0,0,0-1.642,1.883l.171.983a2.452,2.452,0,0,0,2.324,1.955Z",
    transform: "translate(-5898.387 -18966.633)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M621.71,297.429a1.546,1.546,0,0,0-1.573,1.942l.207.976a2.453,2.453,0,0,0,2.394,1.868l29.6-1.083a1.883,1.883,0,0,0,1.89-1.9,2.036,2.036,0,0,0-2.077-1.822Z",
    transform: "translate(-5898.366 -18978.764)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(-5359.822 -18657.018)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M610.348,351.346a1.77,1.77,0,0,0,1.863-1.826,2.1,2.1,0,0,0-2.1-1.842L456.768,346.47c-1.091-.008-1.427.683-.748,1.536l1.423,1.788a4.672,4.672,0,0,0,3.22,1.552Z",
    transform: "translate(-455.669 -346.47)",
    fill: "#e8e8ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894",
    transform: "translate(-5359.822 -18646.871)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M456.768,366.928c-1.091-.008-1.427.683-.748,1.537l1.423,1.787a4.672,4.672,0,0,0,3.22,1.552H610.348a1.77,1.77,0,0,0,1.863-1.826,2.1,2.1,0,0,0-2.1-1.842Z",
    transform: "translate(-455.669 -366.928)",
    fill: "#e8e8ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M454.477,400.614c3.68-.282,10.572-.413,14.365-.466a3.438,3.438,0,0,1,3.394,2.629,56.047,56.047,0,0,1,1.615,13.89,3.053,3.053,0,0,1-3.08,2.989l-14-.151a3.362,3.362,0,0,1-3.311-3.049l-1.231-13.17A2.449,2.449,0,0,1,454.477,400.614Z",
    transform: "translate(-5813.753 -19030.541)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11895",
    "data-name": "Group 11895",
    transform: "translate(-5335.234 -18625.916)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M506.954,411.978a1.579,1.579,0,0,0-1.688,1.879l.38,2.531a2.383,2.383,0,0,0,2.279,1.962H542.2a1.96,1.96,0,0,0,1.959-1.984l-.011-.852a2.124,2.124,0,0,0-2.007-2.067Z",
    transform: "translate(-505.244 -411.977)",
    fill: "#e8e8ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M608.25,400.614c3.68-.282,10.572-.413,14.365-.466a3.438,3.438,0,0,1,3.395,2.629,56.031,56.031,0,0,1,1.615,13.89,3.053,3.053,0,0,1-3.081,2.989l-14-.151a3.362,3.362,0,0,1-3.311-3.049L606,403.288A2.45,2.45,0,0,1,608.25,400.614Z",
    transform: "translate(-5891.258 -19030.541)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11896",
    "data-name": "Group 11896",
    transform: "translate(-5258.966 -18625.916)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M660.727,411.978a1.579,1.579,0,0,0-1.687,1.879l.38,2.531a2.384,2.384,0,0,0,2.279,1.962h34.278a1.96,1.96,0,0,0,1.959-1.984l-.011-.852a2.125,2.125,0,0,0-2.007-2.067Z",
    transform: "translate(-659.018 -411.977)",
    fill: "#e8e8ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M464.938,462.365c9.182-.389,29.14-1.643,38.606-1.716,4.01-.031,7.528,1.469,8.469,3.622,1.827,4.182,1.585,12.517,1.268,20.21-.095,2.3-3.513,4.143-7.687,4.118l-34.93-.208c-4.3-.025-7.862-1.839-8.261-4.2l-3.071-18.143C459.013,464.17,461.534,462.508,464.938,462.365Z",
    transform: "translate(-5817.323 -19061.033)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11897",
    "data-name": "Group 11897",
    transform: "translate(-5353.961 -18566.787)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M469.277,528.4a1.634,1.634,0,0,0-1.781,1.851l.895,8.872a2.247,2.247,0,0,0,2.183,1.974h47.008a1.97,1.97,0,0,0,1.968-1.984l-.047-5.6a2.166,2.166,0,0,0-2-2.107Z",
    transform: "translate(-467.486 -528.397)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M466.98,574.741c3.4-.232,10.777-.982,14.277-1.025a3.13,3.13,0,0,1,3.132,2.164c.676,2.5.586,7.477.469,12.073a2.69,2.69,0,0,1-2.843,2.46l-12.918-.124a2.984,2.984,0,0,1-3.055-2.509l-1.136-10.839A2.1,2.1,0,0,1,466.98,574.741Z",
    transform: "translate(-5820.142 -19118.027)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11898",
    "data-name": "Group 11898",
    transform: "translate(-5353.777 -18524.119)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M469.794,614.435a1.722,1.722,0,0,0-1.936,1.785l.4,20.933a2.036,2.036,0,0,0,2.022,1.983h14.884a1.987,1.987,0,0,0,1.982-1.984l-.024-18.991a2.25,2.25,0,0,0-1.977-2.183Z",
    transform: "translate(-467.858 -614.425)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M517.916,574.741c3.4-.232,10.777-.982,14.277-1.025a3.13,3.13,0,0,1,3.132,2.164c.676,2.5.586,7.477.469,12.073a2.689,2.689,0,0,1-2.843,2.46l-12.918-.124a2.984,2.984,0,0,1-3.056-2.509l-1.135-10.839A2.1,2.1,0,0,1,517.916,574.741Z",
    transform: "translate(-5845.815 -19118.027)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11899",
    "data-name": "Group 11899",
    transform: "translate(-5328.513 -18524.119)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M520.73,614.435a1.722,1.722,0,0,0-1.936,1.785l.4,20.933a2.036,2.036,0,0,0,2.022,1.983H536.1a1.987,1.987,0,0,0,1.981-1.984l-.024-18.991a2.25,2.25,0,0,0-1.977-2.183Z",
    transform: "translate(-518.794 -614.425)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M600.607,477.116h-.035l-12.918-.124a3.473,3.473,0,0,1-3.544-2.954L582.974,463.2a2.357,2.357,0,0,1,.556-1.771,2.838,2.838,0,0,1,1.977-.975h0c1.088-.074,2.621-.2,4.244-.343,3.417-.291,7.669-.653,10.061-.683a3.609,3.609,0,0,1,3.617,2.53c.673,2.488.614,7.2.486,12.215A3.193,3.193,0,0,1,600.607,477.116Zm-15.033-15.673a1.836,1.836,0,0,0-1.284.624,1.371,1.371,0,0,0-.329,1.029l1.136,10.839A2.485,2.485,0,0,0,587.663,476l12.918.124h.026a2.2,2.2,0,0,0,2.316-1.977c.126-4.941.186-9.571-.452-11.931a2.666,2.666,0,0,0-2.647-1.8c-2.356.029-6.589.39-9.989.679-1.627.138-3.164.269-4.26.344Z",
    transform: "translate(-5879.65 -19060.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M589.34,464.914c2.714-.186,8.612-.785,11.41-.819a2.5,2.5,0,0,1,2.5,1.729c.54,2,.469,5.975.375,9.648a2.149,2.149,0,0,1-2.272,1.966l-10.323-.1a2.385,2.385,0,0,1-2.442-2.005l-.908-8.662A1.677,1.677,0,0,1,589.34,464.914Z",
    transform: "translate(-5882.026 -19062.773)",
    fill: "#eeeef2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11900",
    "data-name": "Group 11900",
    transform: "translate(-5268.321 -18594.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    d: "M641.7,472.52a1.413,1.413,0,0,0-1.478,1.871l.691,2.619a2.722,2.722,0,0,0,2.49,1.918h63.2a1.938,1.938,0,0,0,1.941-1.983l-.019-.853a2.1,2.1,0,0,0-2.026-2.031Z",
    transform: "translate(-640.157 -472.52)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    "data-name": "Path 3729",
    d: "M591.1,459.8h0a1.983,1.983,0,0,1,2.735.744l2.548,4.567a.637.637,0,0,0,1.137-.049l6.32-14.07a.706.706,0,0,1,1.349.3,27.779,27.779,0,0,1-8.083,19.332s-3.79-1.473-6.841-8.175A2.079,2.079,0,0,1,591.1,459.8Z",
    transform: "translate(-5883.237 -19055.957)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M600.607,532.938h-.035l-12.918-.124a3.473,3.473,0,0,1-3.544-2.954l-1.135-10.839a2.358,2.358,0,0,1,.556-1.771,2.84,2.84,0,0,1,1.977-.976h0c1.088-.074,2.621-.2,4.244-.343,3.417-.291,7.669-.653,10.061-.683h.052a3.6,3.6,0,0,1,3.565,2.531c.673,2.488.614,7.2.486,12.215A3.192,3.192,0,0,1,600.607,532.938Zm-15.033-15.673a1.836,1.836,0,0,0-1.284.623,1.37,1.37,0,0,0-.329,1.029l1.136,10.839a2.484,2.484,0,0,0,2.567,2.065l12.918.124h.026a2.2,2.2,0,0,0,2.316-1.977c.126-4.941.186-9.572-.452-11.932a2.652,2.652,0,0,0-2.647-1.8c-2.356.03-6.589.39-9.989.68-1.627.138-3.164.269-4.26.345Z",
    transform: "translate(-5879.65 -19088.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M589.34,520.737c2.714-.186,8.612-.785,11.41-.819a2.5,2.5,0,0,1,2.5,1.729c.54,2,.469,5.975.375,9.648a2.15,2.15,0,0,1-2.272,1.966l-10.323-.1a2.385,2.385,0,0,1-2.442-2.005l-.908-8.661A1.677,1.677,0,0,1,589.34,520.737Z",
    transform: "translate(-5882.026 -19090.908)",
    fill: "#eeeef2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11901",
    "data-name": "Group 11901",
    transform: "translate(-5268.321 -18566.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M641.7,528.343a1.414,1.414,0,0,0-1.478,1.871l.691,2.619a2.722,2.722,0,0,0,2.49,1.918h63.2a1.938,1.938,0,0,0,1.941-1.983l-.019-.853a2.1,2.1,0,0,0-2.026-2.031Z",
    transform: "translate(-640.157 -528.343)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M591.1,515.622h0a1.983,1.983,0,0,1,2.735.744l2.548,4.567a.637.637,0,0,0,1.137-.049l6.32-14.07a.706.706,0,0,1,1.349.305,27.778,27.778,0,0,1-8.083,19.332s-3.79-1.473-6.841-8.174A2.08,2.08,0,0,1,591.1,515.622Z",
    transform: "translate(-5883.237 -19084.096)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M600.607,588.761h-.035l-12.918-.124a3.471,3.471,0,0,1-3.544-2.953l-1.135-10.838a2.357,2.357,0,0,1,.557-1.772,2.836,2.836,0,0,1,1.976-.975h0c1.088-.074,2.621-.2,4.244-.343,3.417-.291,7.669-.653,10.061-.683h.052a3.6,3.6,0,0,1,3.565,2.531c.673,2.488.614,7.2.486,12.215A3.192,3.192,0,0,1,600.607,588.761Zm-15.033-15.673a1.834,1.834,0,0,0-1.284.624,1.37,1.37,0,0,0-.329,1.03l1.136,10.839a2.484,2.484,0,0,0,2.567,2.065l12.918.124h.026a2.2,2.2,0,0,0,2.316-1.976c.126-4.941.186-9.572-.452-11.932a2.647,2.647,0,0,0-2.647-1.8c-2.356.03-6.589.39-9.989.68-1.627.139-3.164.269-4.26.345Z",
    transform: "translate(-5879.65 -19116.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M589.34,576.561c2.714-.186,8.612-.784,11.41-.819a2.5,2.5,0,0,1,2.5,1.729c.54,2,.469,5.976.375,9.648a2.15,2.15,0,0,1-2.272,1.966l-10.323-.1a2.385,2.385,0,0,1-2.442-2.005l-.908-8.662A1.677,1.677,0,0,1,589.34,576.561Z",
    transform: "translate(-5882.026 -19119.045)",
    fill: "#eeeef2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11902",
    "data-name": "Group 11902",
    transform: "translate(-5268.321 -18539.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M641.7,584.167a1.413,1.413,0,0,0-1.478,1.871l.691,2.619a2.721,2.721,0,0,0,2.49,1.919h63.2a1.938,1.938,0,0,0,1.941-1.983l-.019-.852a2.1,2.1,0,0,0-2.026-2.031Z",
    transform: "translate(-640.157 -584.167)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M591.1,571.445h0a1.984,1.984,0,0,1,2.735.744l2.548,4.568a.637.637,0,0,0,1.137-.05l6.32-14.07a.706.706,0,0,1,1.349.3,27.778,27.778,0,0,1-8.083,19.332s-3.79-1.473-6.841-8.174A2.08,2.08,0,0,1,591.1,571.445Z",
    transform: "translate(-5883.237 -19112.232)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M600.607,644.585h-.035l-12.918-.124a3.471,3.471,0,0,1-3.544-2.953l-1.135-10.839a2.357,2.357,0,0,1,.557-1.772,2.834,2.834,0,0,1,1.976-.975h0c1.088-.075,2.621-.2,4.244-.343,3.417-.291,7.669-.653,10.061-.683h.052a3.6,3.6,0,0,1,3.565,2.53c.673,2.488.614,7.2.486,12.215A3.192,3.192,0,0,1,600.607,644.585Zm-15.033-15.673a1.835,1.835,0,0,0-1.284.624,1.371,1.371,0,0,0-.329,1.03L585.1,641.4a2.484,2.484,0,0,0,2.567,2.065l12.918.124h.026a2.2,2.2,0,0,0,2.316-1.977c.126-4.941.186-9.572-.452-11.931a2.643,2.643,0,0,0-2.647-1.8c-2.356.03-6.589.39-9.989.68-1.627.138-3.164.269-4.26.344Z",
    transform: "translate(-5879.65 -19144.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M589.34,632.384c2.714-.185,8.612-.785,11.41-.819a2.5,2.5,0,0,1,2.5,1.729c.54,2,.469,5.975.375,9.648a2.15,2.15,0,0,1-2.272,1.966l-10.323-.1a2.386,2.386,0,0,1-2.442-2.005l-.908-8.662A1.677,1.677,0,0,1,589.34,632.384Z",
    transform: "translate(-5882.026 -19147.182)",
    fill: "#eeeef2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11903",
    "data-name": "Group 11903",
    transform: "translate(-5268.321 -18511.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M641.7,639.99a1.413,1.413,0,0,0-1.478,1.871l.691,2.619a2.722,2.722,0,0,0,2.49,1.918h63.2a1.938,1.938,0,0,0,1.941-1.983l-.019-.853a2.1,2.1,0,0,0-2.026-2.03Z",
    transform: "translate(-640.157 -639.99)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M591.1,627.269h0a1.983,1.983,0,0,1,2.735.744l2.548,4.567a.637.637,0,0,0,1.137-.049l6.32-14.07a.706.706,0,0,1,1.349.3,27.779,27.779,0,0,1-8.083,19.332s-3.79-1.473-6.841-8.175A2.079,2.079,0,0,1,591.1,627.269Z",
    transform: "translate(-5883.237 -19140.369)",
    fill: "#e3e3eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11911",
    "data-name": "Group 11911",
    transform: "translate(-5477.591 -18718.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11906",
    "data-name": "Group 11906",
    transform: "translate(28.604 106.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M289.838,453c-2.458.213-6.724.558-10.088.706a9.717,9.717,0,0,1-3.856-.377c0,.076,0,.147.006.213a.7.7,0,0,0,.661.657,118.281,118.281,0,0,0,13.208.013.5.5,0,0,0,.4-.745A4.1,4.1,0,0,0,289.838,453Z",
    transform: "translate(-275.893 -444.502)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M279.749,448.664c3.363-.148,7.63-.493,10.088-.706C287.42,444.993,279.749,443,279.749,443h-2.166a9.089,9.089,0,0,0-1.69,5.292A9.719,9.719,0,0,0,279.749,448.664Z",
    transform: "translate(-275.892 -439.458)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M278.565,435.863l.2,4.012a.917.917,0,0,0,.782.862,3.56,3.56,0,0,0,1.628-.135,1.084,1.084,0,0,0,.729-.833l.7-3.906Z",
    transform: "translate(-277.24 -435.863)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11908",
    "data-name": "Group 11908",
    transform: "translate(0 102.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11907",
    "data-name": "Group 11907",
    transform: "translate(0 3.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M220.01,453.049a1.945,1.945,0,0,1-1.75-1.295l0,.016a1.385,1.385,0,0,0,.933,1.579,6.1,6.1,0,0,0,2.585.4,2.57,2.57,0,0,0,1.938-.894l.006-.008A6.509,6.509,0,0,1,220.01,453.049Z",
    transform: "translate(-218.22 -443.846)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M225.077,435.811H223.29c-2.721-.056-4.43,5.685-4.989,7.907a1.945,1.945,0,0,0,1.75,1.294,6.508,6.508,0,0,0,3.708-.2,17.068,17.068,0,0,0,2.549-6.422A2.255,2.255,0,0,0,225.077,435.811Z",
    transform: "translate(-218.26 -435.81)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M227.783,428.3l-.992,3.946a1.071,1.071,0,0,0,.558,1.214,3.8,3.8,0,0,0,2.054.5.9.9,0,0,0,.73-.6l1.456-4.152Z",
    transform: "translate(-222.523 -428.304)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M226.437,373.589c1.234,1.1,5.249,1.239,5.249,1.239,14.462-34.71,20.378-39.641,20.378-39.641-2.088,13.1-.337,42.106-.337,42.106,2.387,1.053,5.463,0,5.463,0a223.582,223.582,0,0,1,7.385-54.9c-9.774-.22-14.972-3.565-16.67-4.907C239.758,330.621,226.437,373.589,226.437,373.589Z",
    transform: "translate(-222.361 -270.186)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M271.282,236.761c-1.85,9.229-1.187,25.745-.751,33.279.123,2.118-1.356,5.053-2.551,7.056a.628.628,0,0,0,.254.883,43.573,43.573,0,0,0,16.631,4.611,1.121,1.121,0,0,0,1.127-.837C291.818,260,298.585,246.1,298.585,246.1,291.114,234.169,271.282,236.761,271.282,236.761Z",
    transform: "translate(-243.255 -229.379)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M251.331,289.752a31.742,31.742,0,0,0,5.862,13.969l1.335-1.088a41.243,41.243,0,0,1-.665-13.351A15.979,15.979,0,0,0,251.331,289.752Z",
    transform: "translate(-234.909 -255.884)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M264.761,248.39,262.694,237s-13.807,10.554-11.6,26.485a15.979,15.979,0,0,1,6.532-.47C258.253,257.906,260.139,252.356,264.761,248.39Z",
    transform: "translate(-234.667 -229.62)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11910",
    "data-name": "Group 11910",
    transform: "translate(50.001 16.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M324.363,255.831l-5.33,11.478c.862,6.93,4.584,9.926,8.6,11.075a24.348,24.348,0,0,1,1.789-7.475C324.292,265.615,324.363,255.831,324.363,255.831Z",
    transform: "translate(-319.033 -255.831)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M338.159,286.232a24.35,24.35,0,0,0-1.789,7.475c10.709,4.155,13.542-3.9,13.542-3.9l-1.979-.349C343.462,289.926,340.34,288.485,338.159,286.232Z",
    transform: "translate(-327.771 -271.154)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M309.676,224.669l-2.573,9.458a1.84,1.84,0,0,1-2.461,1.225,37.446,37.446,0,0,1-3.708-1.694,2.479,2.479,0,0,1-.874-3.563l5.349-7.976Z",
    transform: "translate(-259.257 -222.118)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M303.192,280.672l-65.929,24a5.048,5.048,0,0,0-2.869,6.834l.2.439a4.692,4.692,0,0,0,6.242,2.316l64.016-29.614Z",
    transform: "translate(-5703.734 -18970.326)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11912",
    "data-name": "Group 11912",
    transform: "translate(-5433.5 -18728.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M322.905,211.229c.023.162-2.146,10.793-2.146,10.793l-6.044-1.368.559-10.381S322.512,208.51,322.905,211.229Z",
    transform: "translate(-310.947 -206.149)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M312.9,208.966l-.722,5.442a.758.758,0,0,0,0,.209c.061.427.379,1.879,1.845,1.463a6.9,6.9,0,0,1,3.392-.443.766.766,0,0,1,.528.886,33.132,33.132,0,0,1-1.391,4.953.764.764,0,0,1-.928.452,24.718,24.718,0,0,1-5.328-2.18.767.767,0,0,1-.373-.69c.058-1.374.218-5.55.083-6.721-.127-1.1-1.476-1.757-2.061-1.993a.753.753,0,0,1-.42-.421,1.988,1.988,0,0,1,1.337-2.9.768.768,0,0,0,.486-.993,1.992,1.992,0,0,1,1.116-2.753,2.81,2.81,0,0,1,3.352.808.767.767,0,0,0,.978.116.607.607,0,0,1,.69.023.755.755,0,0,0,1.069-.324,2.29,2.29,0,0,1,2.66-1.326c2.708.464,3.015,3.465,2.3,5.224s-3.622,1.089-5.081.2c-1.109-.674-2.548.033-3.174.41A.76.76,0,0,0,312.9,208.966Z",
    transform: "translate(-307.211 -202.528)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M309.666,222s1.113-3.118-.03-3.881-2.838-.367-2.465,1.892C307.634,222.823,309.666,222,309.666,222Z",
    transform: "translate(-307.118 -210.209)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M263.489,315.476l6.233-.508,2.7,2.488s-.639.883-2.635.376a28.586,28.586,0,0,0-4.731-.632s-2.756,1.242-2.79-1.082Z",
    transform: "translate(-5718.01 -18987.607)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M361.416,291.611c.539.421,2.386-.458,3.516-1.066a1.3,1.3,0,0,0,.628-1.536c-.272-.858-.725-1.965-1.284-2.1C363.351,286.673,359.195,289.876,361.416,291.611Z",
    transform: "translate(-5767.661 -18973.459)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M239.9,335.931a.256.256,0,0,1-.081-.013c-2.578-.891-3.177-2.414-3.226-3.536a3.927,3.927,0,0,1,2.56-3.784l7.916-3.087a.248.248,0,0,1,.18.462l-7.916,3.087a3.43,3.43,0,0,0-2.245,3.3c.061,1.407,1.034,2.446,2.892,3.088a.248.248,0,0,1-.081.482Z",
    transform: "translate(-5705.068 -18992.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M262.565,323.665a.248.248,0,0,1-.09-.479l1.026-.4a.248.248,0,1,1,.18.462l-1.026.4A.248.248,0,0,1,262.565,323.665Z",
    transform: "translate(-5718.037 -18991.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M315.72,598.2a1.158,1.158,0,0,1-1.158-1.158V458.637a1.158,1.158,0,1,1,2.316,0V597.042A1.158,1.158,0,0,1,315.72,598.2Z",
    transform: "translate(-5744.369 -19059.438)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M252.453,598.2a1.158,1.158,0,0,1-1.158-1.158V458.637a1.158,1.158,0,1,1,2.316,0V597.042A1.158,1.158,0,0,1,252.453,598.2Z",
    transform: "translate(-5712.481 -19059.438)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M97.013,599.078a1.159,1.159,0,0,1-1.065-1.611L155.16,458.184a1.158,1.158,0,0,1,2.132.906L98.079,598.373A1.158,1.158,0,0,1,97.013,599.078Z",
    transform: "translate(-5634.135 -19059.438)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M170.757,599.078a1.159,1.159,0,0,1-1.065-1.611L228.9,458.184a1.158,1.158,0,0,1,2.132.906L171.823,598.373A1.158,1.158,0,0,1,170.757,599.078Z",
    transform: "translate(-5671.304 -19059.438)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    d: "M263.741,459.065H209.5a1.632,1.632,0,0,1-1.632-1.632h0A1.632,1.632,0,0,1,209.5,455.8h54.24a1.632,1.632,0,0,1,1.632,1.632h0A1.632,1.632,0,0,1,263.741,459.065Z",
    transform: "translate(-5690.593 -19058.592)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M234.829,502.736H198.146a1.158,1.158,0,0,1,0-2.316h36.684a1.158,1.158,0,0,1,0,2.316Z",
    transform: "translate(-5685.109 -19081.08)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7991",
    "data-name": "Rectangle 7991",
    width: 36.683,
    height: 2.316,
    transform: "translate(-5498.219 -18554.32)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7992",
    "data-name": "Rectangle 7992",
    width: 36.683,
    height: 2.316,
    transform: "translate(-5509.116 -18527.977)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M167.125,662.071H130.441a1.158,1.158,0,1,1,0-2.316h36.684a1.158,1.158,0,0,1,0,2.316Z",
    transform: "translate(-5650.984 -19161.389)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M144.85,715.184H108.166a1.158,1.158,0,1,1,0-2.316H144.85a1.158,1.158,0,0,1,0,2.316Z",
    transform: "translate(-5639.757 -19188.16)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(-5254.025 -18733.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M945.8,407.04l1.368-.575.006,0a.39.39,0,0,1,.3.719l-.007,0-1.39.554a.376.376,0,0,1-.285-.7Z",
    transform: "translate(-808.388 -300.043)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M954.9,402.922l1.333-.646.007,0a.436.436,0,0,1,.38.786l-.007,0-1.358.626a.422.422,0,0,1-.361-.763Z",
    transform: "translate(-812.97 -297.924)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M963.768,398.325l1.3-.717.007,0a.483.483,0,1,1,.467.845l-.008,0-1.322.7a.469.469,0,0,1-.447-.824Z",
    transform: "translate(-817.437 -295.563)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M972.385,393.267l1.254-.784.008,0a.519.519,0,0,1,.55.88l-.007,0-1.28.776a.509.509,0,0,1-.533-.866Z",
    transform: "translate(-821.781 -292.97)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M980.715,387.736l1.206-.855.008-.005a.553.553,0,1,1,.64.9l-.007,0-1.234.849a.543.543,0,0,1-.622-.89Z",
    transform: "translate(-825.985 -290.135)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M988.711,381.727l1.152-.925.008-.006a.588.588,0,1,1,.736.917l-.007,0-1.181.922a.578.578,0,0,1-.718-.906Z",
    transform: "translate(-830.021 -287.056)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M996.327,375.239l1.09-1,.009-.008a.623.623,0,0,1,.84.92l-.007.005-1.122,1a.613.613,0,0,1-.82-.91Z",
    transform: "translate(-833.868 -283.733)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M1003.513,368.274l1.02-1.064.009-.01a.658.658,0,0,1,.949.91l-.007.006-1.054,1.069a.647.647,0,0,1-.928-.9Z",
    transform: "translate(-837.499 -280.166)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M1010.214,360.836l.941-1.132.01-.011a.692.692,0,0,1,1.065.885l-.006.007-.977,1.141a.682.682,0,0,1-1.043-.878Z",
    transform: "translate(-840.888 -276.359)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M1016.367,352.943l.854-1.2.009-.013a.727.727,0,1,1,1.184.844l-.006.008-.89,1.213a.716.716,0,0,1-1.161-.84Z",
    transform: "translate(-844.002 -272.318)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M1021.922,344.629l.761-1.258.009-.015a.75.75,0,1,1,1.284.777l0,.005-.79,1.282a.744.744,0,0,1-1.271-.775Z",
    transform: "translate(-846.815 -268.068)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M1026.819,335.913l.655-1.313.008-.017a.772.772,0,0,1,1.381.689l0,.005-.683,1.342a.766.766,0,0,1-1.368-.688Z",
    transform: "translate(-849.297 -263.613)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M1030.977,326.829l.534-1.365.008-.021a.793.793,0,1,1,1.477.578l0,.006-.562,1.4a.786.786,0,0,1-1.463-.579Z",
    transform: "translate(-851.406 -258.968)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M1034.288,317.414l.406-1.409.006-.021a.814.814,0,0,1,1.565.451l0,.006-.431,1.448a.808.808,0,0,1-1.55-.453Z",
    transform: "translate(-853.087 -254.158)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M1036.732,307.747l.277-1.439,0-.022a.835.835,0,0,1,1.641.316v.007l-.3,1.48a.829.829,0,0,1-1.626-.32Z",
    transform: "translate(-854.329 -249.225)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M1038.3,297.91l.147-1.458,0-.023a.857.857,0,1,1,1.7.172v.007l-.165,1.5a.85.85,0,0,1-1.691-.178Z",
    transform: "translate(-855.126 -244.21)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M1038.99,287.985l.016-1.464V286.5a.878.878,0,0,1,1.755.019v.007l-.029,1.511a.871.871,0,0,1-1.742-.025Z",
    transform: "translate(-855.476 -239.155)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M1038.653,278.051l-.119-1.458,0-.025a.9.9,0,1,1,1.792-.146v.008l.111,1.509a.892.892,0,0,1-1.78.138Z",
    transform: "translate(-855.244 -234.098)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M1037.375,268.2l-.257-1.438,0-.027a.92.92,0,0,1,1.811-.324v.008l.254,1.493a.914.914,0,0,1-1.8.314Z",
    transform: "translate(-854.523 -229.085)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M1035.145,258.519l-.4-1.4-.008-.028a.941.941,0,0,1,1.81-.515l0,.008.4,1.463a.935.935,0,0,1-1.8.5Z",
    transform: "translate(-853.315 -224.165)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M1031.941,249.126l-.544-1.352-.012-.029a.962.962,0,1,1,1.785-.718l0,.008.555,1.414a.956.956,0,0,1-1.776.706Z",
    transform: "translate(-851.608 -219.395)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M1027.747,240.145l-.687-1.282-.016-.03a.98.98,0,1,1,1.728-.926l0,0,.712,1.345a.977.977,0,1,1-1.726.915Z",
    transform: "translate(-849.397 -214.841)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M1022.583,231.709l-.83-1.192-.02-.029a.987.987,0,1,1,1.621-1.128v0l.867,1.252a.985.985,0,0,1-1.62,1.121Z",
    transform: "translate(-846.689 -210.58)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    d: "M1016.465,223.966c-.322-.361-.638-.728-.968-1.082a.995.995,0,0,1,1.453-1.358l0,0,0,0c.346.372.677.759,1.014,1.139a.992.992,0,1,1-1.485,1.316Z",
    transform: "translate(-843.5 -206.686)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M1009.429,217l-1.093-.957-.026-.023a1,1,0,1,1,1.32-1.506l0,0,1.143,1.007a1,1,0,0,1-1.322,1.5Z",
    transform: "translate(-839.841 -203.187)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M1001.628,210.93l-1.2-.825-.028-.019a1.008,1.008,0,0,1,1.145-1.66h0l1.25.868a1.006,1.006,0,1,1-1.147,1.653Z",
    transform: "translate(-835.808 -200.152)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M993.187,205.771l-1.282-.689-.029-.015a1.015,1.015,0,0,1,.962-1.788h0l1.337.724a1.013,1.013,0,1,1-.965,1.782Z",
    transform: "translate(-831.461 -197.587)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M984.238,201.545l-1.348-.552-.029-.012a1.022,1.022,0,1,1,.774-1.892h0l1.4.579a1.02,1.02,0,1,1-.778,1.886Z",
    transform: "translate(-826.865 -195.499)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M974.9,198.258l-1.4-.414-.029-.008a1.029,1.029,0,0,1,.584-1.974h0l1.455.435a1.027,1.027,0,1,1-.588,1.968Z",
    transform: "translate(-822.081 -193.888)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M965.278,195.909l-1.431-.276-.03-.005a1.036,1.036,0,1,1,.392-2.034h0l1.489.291a1.034,1.034,0,1,1-.4,2.029Z",
    transform: "translate(-817.163 -192.757)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M955.467,194.5l-1.453-.137-.03,0a1.043,1.043,0,0,1,.2-2.077h0l1.512.147a1.041,1.041,0,1,1-.2,2.072Z",
    transform: "translate(-812.155 -192.101)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M945.57,194.025h-1.49a1.05,1.05,0,1,1,0-2.1h0l1.521,0a1.048,1.048,0,0,1,0,2.1Z",
    transform: "translate(-807.109 -191.926)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M935.676,194.357l-1.451.143-.031,0a1.057,1.057,0,1,1-.207-2.1h0l1.513-.144a1.055,1.055,0,1,1,.2,2.1Z",
    transform: "translate(-802.071 -192.089)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M925.881,195.645l-1.432.28-.028.005a1.064,1.064,0,0,1-.409-2.088h0l1.489-.287a1.062,1.062,0,1,1,.4,2.085Z",
    transform: "translate(-797.091 -192.737)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M916.251,197.836l-1.4.407-.027.008a1.071,1.071,0,0,1-.6-2.057h0l1.457-.418a1.069,1.069,0,1,1,.589,2.054Z",
    transform: "translate(-792.202 -193.845)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M906.856,200.865l-1.364.524-.025.009a1.078,1.078,0,1,1-.774-2.012h0l1.415-.54a1.076,1.076,0,0,1,.767,2.01Z",
    transform: "translate(-787.439 -195.378)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M897.752,204.671l-1.318.633-.023.011a1.085,1.085,0,0,1-.94-1.955h0l1.366-.652a1.082,1.082,0,0,1,.932,1.954Z",
    transform: "translate(-782.829 -197.307)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M888.99,209.194l-1.268.731-.021.012a1.088,1.088,0,0,1-1.089-1.884l1.308-.758a1.089,1.089,0,1,1,1.093,1.885h0Z",
    transform: "translate(-778.4 -199.599)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M880.6,214.381l-1.21.821-.019.013a1.08,1.08,0,0,1-1.216-1.785l1.246-.852a1.082,1.082,0,1,1,1.222,1.786l0,0Z",
    transform: "translate(-774.174 -202.24)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M872.615,220.169l-1.151.908-.018.014a1.072,1.072,0,0,1-1.33-1.681l1.183-.939a1.074,1.074,0,1,1,1.336,1.683l0,0Z",
    transform: "translate(-770.154 -205.188)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M865.053,226.516l-1.088.987-.016.014a1.064,1.064,0,0,1-1.432-1.574l1.116-1.019a1.066,1.066,0,0,1,1.438,1.575l0,0Z",
    transform: "translate(-766.354 -208.417)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M857.943,233.374l-1.018,1.057-.015.015a1.056,1.056,0,0,1-1.524-1.463l1.045-1.092a1.059,1.059,0,0,1,1.53,1.464l0,0Z",
    transform: "translate(-762.786 -211.906)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M851.312,240.7l-.945,1.122-.014.016a1.048,1.048,0,0,1-1.605-1.348l.968-1.157a1.05,1.05,0,0,1,1.611,1.348l0,0Z",
    transform: "translate(-759.466 -215.632)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M845.165,248.452l-.879,1.179-.011.014a1.04,1.04,0,0,1-1.67-1.24l.9-1.21a1.042,1.042,0,1,1,1.676,1.24l0,0Z",
    transform: "translate(-756.39 -219.57)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M839.449,256.548l-.819,1.225-.008.012a1.032,1.032,0,0,1-1.718-1.145l.831-1.252a1.035,1.035,0,0,1,1.724,1.145l0,0Z",
    transform: "translate(-753.532 -223.68)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M834.116,264.921l-.768,1.261-.006.01a1.024,1.024,0,0,1-1.752-1.062l.776-1.284a1.027,1.027,0,0,1,1.758,1.062l0,0Z",
    transform: "translate(-750.866 -227.926)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M829.1,273.51l-.725,1.289,0,.007a1.016,1.016,0,0,1-1.773-.994l.73-1.307a1.019,1.019,0,1,1,1.778.993v0Z",
    transform: "translate(-748.361 -232.277)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M824.347,282.26l-.693,1.309,0,.006a1.008,1.008,0,0,1-1.783-.941l.695-1.323a1.011,1.011,0,0,1,1.789.94v0Z",
    transform: "translate(-745.981 -236.706)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M819.773,291.125l-.672,1.322,0,0a1,1,0,0,1-1.786-.9l.671-1.331a1,1,0,0,1,1.792.9l0,0Z",
    transform: "translate(-743.691 -241.189)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M815.311,300.062l-.662,1.332a.992.992,0,0,1-1.78-.878l.659-1.338a.995.995,0,0,1,1.785.879Z",
    transform: "translate(-741.453 -245.704)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M810.886,309.035l-.662,1.336a.985.985,0,0,1-1.765-.873l.657-1.336a.987.987,0,1,1,1.772.87Z",
    transform: "translate(-739.231 -250.233)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M806.428,318.006l-.673,1.333a.976.976,0,1,1-1.743-.88h0l.666-1.33v0a.979.979,0,0,1,1.751.877Z",
    transform: "translate(-736.988 -254.758)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M801.872,326.941l-.7,1.322a.953.953,0,0,1-1.69-.882l0-.005.681-1.318,0,0a.96.96,0,1,1,1.707.881Z",
    transform: "translate(-734.705 -259.267)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M797.132,335.8l-.731,1.306a.929.929,0,0,1-1.627-.9l0-.008.71-1.3,0-.007a.936.936,0,1,1,1.643.9Z",
    transform: "translate(-732.328 -263.741)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M792.12,344.532l-.781,1.28a.905.905,0,0,1-1.551-.935l.006-.01.757-1.269.005-.009a.913.913,0,0,1,1.568.935Z",
    transform: "translate(-729.807 -268.144)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M786.759,353.062l-.835,1.246a.882.882,0,0,1-1.47-.974l.007-.01.81-1.234.006-.01a.889.889,0,1,1,1.487.975Z",
    transform: "translate(-727.11 -272.445)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M781.017,361.348l-.895,1.205a.858.858,0,0,1-1.383-1.015l.008-.011.868-1.192.007-.011a.865.865,0,0,1,1.4,1.018Z",
    transform: "translate(-724.22 -276.623)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M774.86,369.341l-.96,1.156a.834.834,0,0,1-1.289-1.059l.01-.012.93-1.143.009-.011a.841.841,0,1,1,1.3,1.062Z",
    transform: "translate(-721.12 -280.653)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M768.251,376.976l-1.031,1.1a.81.81,0,0,1-1.186-1.1l.012-.012,1-1.082.011-.012a.817.817,0,1,1,1.2,1.109Z",
    transform: "translate(-717.791 -284.502)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M761.154,384.175l-1.106,1.021a.786.786,0,0,1-1.073-1.15l.013-.012,1.07-1.008.013-.012a.794.794,0,1,1,1.088,1.156Z",
    transform: "translate(-714.217 -288.131)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M753.541,390.838l-1.186.931a.763.763,0,0,1-.948-1.195l.016-.012,1.146-.918.015-.012a.77.77,0,1,1,.962,1.2Z",
    transform: "translate(-710.383 -291.49)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M745.392,396.851l-1.267.821a.739.739,0,0,1-.81-1.236l.018-.012,1.223-.809.017-.011a.746.746,0,1,1,.823,1.244Z",
    transform: "translate(-706.282 -294.522)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M736.724,402.077l-1.346.685a.706.706,0,0,1-.651-1.253l.021-.011,1.295-.685.02-.01a.718.718,0,0,1,.672,1.269Z",
    transform: "translate(-701.93 -297.163)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M727.568,406.379l-1.414.533a.667.667,0,0,1-.481-1.244l.022-.009,1.362-.539.021-.008a.679.679,0,0,1,.5,1.263Z",
    transform: "translate(-697.343 -299.354)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M718.012,409.627c-.489.121-.976.249-1.466.365a.628.628,0,0,1-.3-1.221l.009,0c.473-.12.944-.251,1.417-.376l.023-.006a.64.64,0,0,1,.327,1.238Z",
    transform: "translate(-692.566 -301.018)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M708.126,411.677l-1.51.151a.589.589,0,0,1-.127-1.171l.03,0,1.449-.168.029,0a.6.6,0,0,1,.138,1.194Z",
    transform: "translate(-687.624 -302.082)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M698.069,412.009l-1.52-.142a.55.55,0,0,1,.093-1.1l.038,0,1.448.113.037,0a.562.562,0,1,1-.087,1.12Z",
    transform: "translate(-682.625 -302.229)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M688.246,409.929c-.481-.175-.967-.328-1.442-.521a.511.511,0,0,1,.377-.951l.006,0c.447.173.912.311,1.365.469l.044.015a.523.523,0,0,1-.344.987Z",
    transform: "translate(-677.804 -301.046)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M679.4,405.115l-1.207-.946a.469.469,0,0,1,.57-.744l.037.028,1.152.867.037.028a.484.484,0,0,1-.582.774Z",
    transform: "translate(-673.534 -298.48)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M672.624,397.726l-.817-1.3a.416.416,0,0,1,.7-.451l.027.041.791,1.2.027.04a.433.433,0,1,1-.723.476Z",
    transform: "translate(-670.374 -294.677)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M669.163,388.727l-.176-1.137a.368.368,0,0,1,.727-.121l.007.038.187,1.057.007.038a.38.38,0,1,1-.749.132Z",
    transform: "translate(-668.982 -290.332)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(-5285.216 -18674.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M660.547,365.144l-4.993,7.534-2.956-6.621Z",
    transform: "translate(-629.533 -338.367)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M606.092,311.154l8.52,31.332a2.288,2.288,0,0,0,2.89,1.583l31.136-9.739a.917.917,0,0,0,.138-1.694Z",
    transform: "translate(-606.092 -311.154)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M637.1,337.931l-31.012-26.777,25.992,28.364-1.3,2.148Z",
    transform: "translate(-606.092 -311.154)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M652.483,369.261l3.013,5.029-.03-5.948Z",
    transform: "translate(-629.474 -339.979)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11926",
    "data-name": "Group 11926",
    transform: "translate(-5270.818 -18627.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M713.244,450.376s3.288,1.6,3.893,3.437c.485,1.474,4.121,1.664,4.481,4.563A3.327,3.327,0,0,0,724.4,461.3c3.714.569,9.437,2.5,10.352,8.945.7,4.922-1.81,6.788-4.443,7.434a3.73,3.73,0,0,0-2.828,4.308c.375,1.872-.184,4.037-3.429,5.749-7.27,3.836-14.53-9.088-14.53-9.088l-1.488-22.567Z",
    transform: "translate(-671.873 -428.285)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M647.968,426.381s9.355,25.5,25.295,33.472c0,0-5.305,8.656-8.074,9.181,0,0-17.028-21.794-18.764-39.649Z",
    transform: "translate(-640.819 -416.191)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M778.778,734.171l.47,3.868a1.6,1.6,0,0,0,1.4,1.4,24.735,24.735,0,0,0,5.176.081,1.368,1.368,0,0,0,1.149-1.774,14.09,14.09,0,0,0-2.595-5.053h-4.29A1.321,1.321,0,0,0,778.778,734.171Z",
    transform: "translate(-707.524 -570.579)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M707.76,644.329l-.724,4.26s2.425,24.563,2.856,34.388a7.7,7.7,0,0,1-1.139,4.376l-4.217,6.847,10.717-6.324.213-1.308-1.754-2.412,2.3-27.517a8.443,8.443,0,0,0-.961-4.67l-2.216-4.164Z",
    transform: "translate(-670.109 -526.043)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M702.194,736.548h3.42a2.058,2.058,0,0,0,1.634-.8c1.066-1.385,3.275-4.088,4.331-4.158,1.422-.1,1.24,4.96,1.24,4.96h.8l1.009-6.281a3.717,3.717,0,0,0-1.951-3.886h0a5.258,5.258,0,0,1-2.087,3.467c-1.762,1.063-7.172,4.87-7.172,4.87a4.892,4.892,0,0,0-1.39.037A.9.9,0,0,0,702.194,736.548Z",
    transform: "translate(-668.473 -567.399)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M740.63,646.61s14.207,26.948,16.465,33.1a59.1,59.1,0,0,1,3.079,11.771c.047.759.992,1.488,3.6,1.488a2.5,2.5,0,0,0,2.324-1.06,1.519,1.519,0,0,0,.058-1.471c-.822-1.663-3.43-6.978-4.4-9.388-1.153-2.878-3.634-15.921-4.994-20.456s-2.9-9.454-8.822-13.985C747.94,646.61,743.874,642.627,740.63,646.61Z",
    transform: "translate(-688.301 -526.3)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M702.225,526.361c-3.665-15.528,5.619-24.311,5.619-24.311-5.857-5.622-16.53-8.181-16.53-8.181s-10.184,7.445-8.976,13.273c.708,3.415,7.158,20.459,7.158,20.459A14.173,14.173,0,0,0,702.225,526.361Z",
    transform: "translate(-658.87 -450.207)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M716.974,567.069c-1.491-4.493-8.125-7.688-8.125-7.688a14.174,14.174,0,0,1-12.729,1.24,25.536,25.536,0,0,0-.414,9.864c.923,4.751,6.715,35.287,6.715,35.287,9.126,1.849,23.163-1.86,23.163-1.86C719.771,593.591,718.466,571.561,716.974,567.069Z",
    transform: "translate(-665.495 -483.227)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M708.108,471.883l2.979,13.383c.285,1.179-.79.986-1.981.761-1.952-.368-4.467-1.126-5.308-2.644a1.445,1.445,0,0,1-.153-.5l-1.28-9.28a1.667,1.667,0,0,1,.976-1.752l2.47-1.1A1.668,1.668,0,0,1,708.108,471.883Z",
    transform: "translate(-669.007 -438.482)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M729.018,510.364s20.795,14.878,2.659,30.511a4.686,4.686,0,0,1-2.052,1.189,22.578,22.578,0,0,0-3.748,2.544.706.706,0,0,1-1.032-.186h0a.964.964,0,0,1-.054-.924l2.574-5.444a1.986,1.986,0,0,1,2.579-.112h0a.979.979,0,0,0,1.485-.336c1.4-2.855,4.049-11.253-6.785-20.742a1.174,1.174,0,0,1-.26-1.427C725.145,513.975,726.886,511.071,729.018,510.364Z",
    transform: "translate(-680.045 -458.521)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(28.537 15.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M699.729,447.274s-3.529,1.49-5.928,6.589-.608,7.453,1.643,7.776a10.536,10.536,0,0,0,9.177-3.02C708.18,455.325,704.315,445.508,699.729,447.274Z",
    transform: "translate(-692.66 -442.518)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M705.607,451.278s2.662-7.459-3.952-7.548l-1.556,1.088s-2.427-4.136,1.556-6.11,8.645-.344,10.34,5.023,1.984,8.958-.835,11.525-3.982-.344-3.982-.344,1.535-2.4.91-3.686-2.067.266-2.067.266Z",
    transform: "translate(-696.041 -437.899)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M713.444,463.834s1.346-3.843,3.142-2.313-1.459,3.55-2.733,4.2Z",
    transform: "translate(-703.136 -449.624)",
    fill: "#f8ac72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11925",
    "data-name": "Group 11925",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M641.374,420.667c-.143.454,1.51,1.145,2.483-.711.034-.889.575-4.7.044-5.424a70.965,70.965,0,0,0-8.318-8.7,1.306,1.306,0,0,0-.164,1.814l2.662,2.773a12.894,12.894,0,0,0-1.554,3.073,3.73,3.73,0,0,0,.372,2.746c.467.842,1.1,1.936,1.708,2.793A3.683,3.683,0,0,0,641.374,420.667Z",
    transform: "translate(-635.123 -405.836)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M643.417,424.959a26,26,0,0,0-1.235-4.856,1.553,1.553,0,0,1-.295-1.221,1.132,1.132,0,0,1,.636-.691l.147-.075,2.6,2.206.785,2.109-.465.172-.739-1.987-2.243-1.9a.559.559,0,0,0-.245.3,1.136,1.136,0,0,0,.24.828,27.248,27.248,0,0,1,1.3,5.028Z",
    transform: "translate(-638.514 -412.025)",
    fill: "#f8ac72"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11929",
    "data-name": "Group 11929",
    transform: "translate(-5197.043 -18544.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(32.202 33.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M848.981,677.98s17.346,25.083,35.564,17.866c14.641-5.8-4.992-6.378-20.946-12.148a1.043,1.043,0,0,1,.626-1.988c12.629,3.407,32.06,7.4,36.355,1.146,6.483-9.438,1.061-6.817-14.786-7.428s-18.351-4.876-7.815-5.93,26.085,6.423,30.528,1.973,7.814-14,9.883-18.031-18.085-13.15-24.5-8.353-12.66,16.572-19.7,17.941,1.662-8.627,6.878-13.69,7.544-9.031-1.56-8.865-15.264,10.434-17.282,18.441-5.764,12.138-5.089,8.134,3.769-16.146,7.112-19.478S846.639,646.069,848.981,677.98Z",
    transform: "translate(-848.798 -640.469)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M852.3,695.863a.268.268,0,0,0,.277-.013c19.455-12.943,50.164-20.157,50.472-20.228a.269.269,0,0,0-.122-.525c-.309.071-31.112,7.306-50.649,20.3a.27.27,0,0,0-.075.373A.266.266,0,0,0,852.3,695.863Z",
    transform: "translate(-850.492 -657.919)",
    fill: "#fff",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M802.1,656.694s36.933,6.137,46.133-16.089c7.395-17.863-9.888-1.048-28.6,8.087a1.281,1.281,0,0,1-1.218-2.251c13.793-8.223,33.911-21.944,32.069-31.071-2.781-13.778-5.1-6.759-19.18,6.689s-19.976,12.012-11.9,1.823,27.948-17.51,27.82-25.227-5.671-18.852-7.453-24.116-27.043,4.71-28.291,14.46,3.794,25.318-1.009,32.691-6.186-8.835-6.194-17.759-1.517-14.366-9.148-6.2-3.841,22.371,1.493,30.989,5.777,15.451,2.824,11.435-11.015-17.117-11.095-22.911S771.965,631.5,802.1,656.694Z",
    transform: "translate(-783.87 -573.083)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M823.754,675.97a.329.329,0,0,0,.226-.255c5.209-28.209,25.085-61.445,25.286-61.777a.33.33,0,1,0-.566-.341c-.2.333-20.138,33.67-25.37,62a.331.331,0,0,0,.265.385A.324.324,0,0,0,823.754,675.97Z",
    transform: "translate(-803.756 -593.422)",
    fill: "#fff",
    opacity: 0.53
  }))), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_7994",
    "data-name": "Rectangle 7994",
    width: 68.68,
    height: 68.68,
    transform: "translate(-5359.822 -18733.334)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11932",
    "data-name": "Group 11932",
    transform: "translate(-5396.036 -18739.645)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1503",
    "data-name": "Ellipse 1503",
    cx: 32.545,
    cy: 31.958,
    rx: 32.545,
    ry: 31.958,
    transform: "translate(5.022 3.601)",
    opacity: 0.5,
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M397.864,179.871c-20,0-36.214,15.921-36.214,35.561s16.214,35.561,36.214,35.561,36.214-15.921,36.214-35.561S417.865,179.871,397.864,179.871Zm0,65.9c-17.063,0-30.895-13.582-30.895-30.337s13.832-30.337,30.895-30.337,30.895,13.582,30.895,30.337S414.927,245.769,397.864,245.769Z",
    transform: "translate(-361.65 -179.871)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M366.722,222.074a.248.248,0,0,1-.246-.217c-.108-.841-.183-1.7-.225-2.55a.248.248,0,0,1,.235-.26.237.237,0,0,1,.26.236c.041.838.116,1.684.222,2.512a.248.248,0,0,1-.215.278Zm.249-9.944a.267.267,0,0,1-.044,0,.248.248,0,0,1-.2-.288,32.762,32.762,0,0,1,1.954-6.688,33.849,33.849,0,0,1,31.5-20.851,34.321,34.321,0,0,1,18.242,5.213.248.248,0,0,1-.263.421,33.823,33.823,0,0,0-17.979-5.137,33.356,33.356,0,0,0-31.043,20.543h0a32.243,32.243,0,0,0-1.924,6.586A.248.248,0,0,1,366.971,212.131Z",
    transform: "translate(-363.994 -182.107)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationArt);
export default __webpack_public_path__ + "static/media/registration-art.1782e123fc779019f4e8627229c927ec.svg";
export { ForwardRef as ReactComponent };